"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitButton = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../Button/index.js");
const index_js_2 = require("../IconButton/index.js");
const index_js_3 = require("../../DropdownMenu/index.js");
const index_js_4 = require("../../utils/index.js");
require("@itwin/itwinui-css/css/button.css");
/**
 * Split button component with a DropdownMenu.
 *
 * The delegated props and forwarded ref are passed onto the primary button.
 * It also supports using the `as` prop to change which element is rendered.
 *
 * @example
 * const menuItems = (close: () => void) => [
 *   <MenuItem key={1} onClick={onClick(1, close)}>Item #1</MenuItem>,
 *   <MenuItem key={2} onClick={onClick(2, close)}>Item #2</MenuItem>,
 * ];
 * <SplitButton onClick={onClick} menuItems={menuItems}>Default</SplitButton>
 * <SplitButton onClick={onClick} menuItems={menuItems} styleType='high-visibility'>High visibility</SplitButton>
 */
exports.SplitButton = React.forwardRef((props, forwardedRef) => {
    const { onClick, menuItems, className, menuPlacement = 'bottom-end', styleType = 'default', size, children, style, title, ...rest } = props;
    (0, index_js_4.useTheme)();
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const [menuWidth, setMenuWidth] = React.useState(0);
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (ref.current) {
            setMenuWidth(ref.current.offsetWidth);
        }
    }, [children, size]);
    return (React.createElement("span", { className: (0, classnames_1.default)(className, 'iui-button-split', {
            'iui-disabled': props.disabled,
        }), style: style, title: title, ref: ref },
        React.createElement(index_js_1.Button, { styleType: styleType, size: size, onClick: onClick, ref: forwardedRef, ...rest }, children),
        React.createElement(index_js_3.DropdownMenu, { placement: menuPlacement, menuItems: menuItems, style: { minWidth: menuWidth }, onShow: React.useCallback(() => setIsMenuOpen(true), []), onHide: React.useCallback(() => setIsMenuOpen(false), []) },
            React.createElement(index_js_2.IconButton, { styleType: styleType, size: size, disabled: props.disabled }, isMenuOpen ? React.createElement(index_js_4.SvgCaretUpSmall, null) : React.createElement(index_js_4.SvgCaretDownSmall, null)))));
});
exports.default = exports.SplitButton;
